// extracted by mini-css-extract-plugin
export var content = "_lm-1";
export var fullScreen = "_lm-0";